import styles from './Header.module.css';
import { useState } from 'react';
import NaviButton from '../compoenets/NaviButton';
import HowToMakeNs from './HowToMakeNs';


export default function Header({className,title,scrolled}) {
  const [accountToggle,setAccountToggle]= useState(false);
 

  const handleSignOut=()=>{
    localStorage.removeItem("account");
    window.location.href="/";
  }

  return (
    <div className={`${className} ${styles['header-wrap']}`}>
      {/* <div className={styles['header-logo']}>
        <span onClick={()=>{viewNavigate("/")}}>SAMUEL</span>
        <NamespaceDropdown 
          onSearch={()=>setIsNamespaceSearch(true)}
          onHow={()=>setIsHowToMakeNs(true)}
        />
      </div> */}
      <div className={`${styles['header-title']} ${scrolled && styles["scrolled-on"]}`}>{title}</div>
      <div className={styles['header-widget']}>
        <NaviButton to="/task-list" className={`${styles["widget-btn"]} ${styles["widget-btn-prev"]} ${scrolled && styles["scrolled-on"]}`}><p>&lt;</p>Task List</NaviButton>
        <NaviButton to="/new-task-data" className={`${styles["widget-btn"]} ${styles["widget-btn-next"]} ${scrolled && styles["scrolled-on"]}`}>New Task</NaviButton>
        <div className={styles['widget-alarm']}></div>
        <div className={`
          ${styles['widget-account']}
          ${accountToggle && styles['widget-account-on']}
          `} 
          onClick={()=>{setAccountToggle(!accountToggle)}
        }>
        </div>
      </div>
      <div className={`
        ${styles['account-menu']} 
        ${accountToggle ? styles['account-menu-on'] : styles['account-menu-off']}
      `}>
        <div className={styles['account-menu-body']}>
          <span>{localStorage.getItem("account")?JSON.parse(localStorage.getItem("account")).mail:"Anonymous"}</span>
          <span>AI Platform Team</span>
        </div>
        <hr></hr>
          <button className={styles['account-menu-logout']} onClick={handleSignOut}>Sign out</button>
      </div>
    </div>
  );
}